import Component from '@glimmer/component';
import { HeadlessForm } from '@universal-ember/form';
import { validateChangeset } from '@universal-ember/form-changeset';
import { Changeset } from 'ember-changeset';
import { lookupValidator } from 'validated-changeset';

const validations = {
  name: (key, newValue) => (newValue ? true : `${key} can't be blank`),
  email: (key, newValue) =>
    /^[^@\s]+@[^@\s]+$/.test(newValue ?? '')
      ? true
      : `${key} must be a valid email address`,
};

export default class MyFormComponent extends Component {
  changeset = Changeset({}, lookupValidator(validations), validations);

  handleSubmit = ({ name, email }) => {
    alert(`Form submitted with: ${name} ${email}`);
  };

  <template>
    <HeadlessForm
      @data={{this.changeset}}
      @dataMode="mutable"
      @onSubmit={{this.handleSubmit}}
      @validate={{(validateChangeset)}}
      as |form|
    >
      <form.Field @name="name" as |field|>
        <div class="my-2 flex flex-col">
          <field.Label>Name</field.Label>
          <field.Input class="border rounded px-2" />
          <field.Errors />
        </div>
      </form.Field>

      <form.Field @name="email" as |field|>
        <div class="my-2 flex flex-col">
          <field.Label>Email</field.Label>
          <field.Input class="border rounded px-2" />
          <field.Errors />
        </div>
      </form.Field>

      <button type="submit">Submit</button>
    </HeadlessForm>
  </template>
}